import React, { FC } from "react";
import { ChipProps } from "@mui/material";

import { chipColors, StyledChip } from "./Chip.styled";

interface Chip extends ChipProps {
  type: keyof typeof chipColors;
}

const Chip: FC<Chip> = (props) => {
  const { type, ...rest } = props;

  return <StyledChip {...rest} type={String(type)} />;
};

export default Chip;
